module.exports = __webpack_public_path__ + "static/media/to-right.63213d24.svg";